import handleResponse from "../utils/handleresponse";

export const demandcertificationService = {
    createCommodity
};

function createCommodity(data) {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
    };
    return fetch(`${process.env.REACT_APP_API_URL}/certificate/create`, requestOptions)
        .then(handleResponse)
        .then(result=>{
            return result;
        });
}